<template>
  <div class="expressao-valor">
    <div class="expr-toggle">
      <button
        type="button"
        class="pill"
        :class="{ 'pill--active': value && value.tipo === 'literal' }"
        @click="setTipo('literal')"
      >
        Estático
      </button>
      <button
        type="button"
        class="pill"
        :class="{ 'pill--active': value && value.tipo === 'campo' }"
        @click="setTipo('campo')"
      >
        Campo
      </button>
    </div>

    <input
      v-if="value && value.tipo === 'literal'"
      class="form-control form-control-sm"
      type="text"
      :value="value.valor"
      :placeholder="placeholder || 'Valor literal'"
      @input="onLiteralInput"
    />

    <select
      v-else-if="value && value.tipo === 'campo'"
      class="form-control form-control-sm"
      :value="value.caminho"
      @change="onCampoChange"
    >
      <option value="">Selecione um campo</option>
      <option v-for="c in campos" :key="c.value" :value="c.value">{{ c.label }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ExpressaoValor",
  props: {
    value: {
      type: Object,
      default: () => ({ tipo: "literal", valor: "" }),
    },
    campos: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  methods: {
    setTipo(tipo) {
      const novo = tipo === "literal"
        ? { tipo: "literal", valor: "" }
        : { tipo: "campo", caminho: "" };
      this.$emit("input", novo);
    },
    onLiteralInput(e) {
      this.$emit("input", { tipo: "literal", valor: e.target.value });
    },
    onCampoChange(e) {
      this.$emit("input", { tipo: "campo", caminho: e.target.value });
    },
  },
};
</script>

<style scoped>
.expressao-valor {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.expr-toggle {
  display: flex;
  gap: 4px;
}
.pill {
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid #dddce9;
  background: #fff;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
}
.pill--active {
  background: #3a3e81;
  border-color: #3a3e81;
  color: #fff;
}
</style>
